import './App.css';
import ComplexNavbar from './resources/navbar.js'
import Footer from './resources/Footer.js'
import Loader from './components/Loader/Loader.js';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import Home from './components/Home.js';
// Page stylesheets stay in the main bundle, in their original order: several contain global
// rules (body, *, input, label) that every page relies on. Only the page code is lazy-loaded.
import './components/UpdateUserForm.css';
import './components/InfoPages.css';
import Login from "./components/User_Auth/Login";
import './components/BidHistory.css';
import React, { Suspense, useEffect, useRef, useState } from "react";
import { useSelector,useDispatch } from 'react-redux';
import ProtectedRoute from "./ProtectedRoute";
import 'react-toastify/dist/ReactToastify.css';
import './toast.css';
import {ToastContainer } from 'react-toastify';
import { toastCss } from './constant/constant.js';
import { toast} from 'react-toastify';
import './components/HowToPlay.css';
import { get_all_depends,clearmsg_promt,logged_user_storage,setFcmToken } from './features/userSlice.js';
import './components/GameType.css';
import './components/payment/ad.css';
import './components/sangam.css';
import './components/play/PlayGame.css';
import './components/Play_component.css';
import './components/User_Auth/MpinForm.css';
import './components/Chart.css';
import LoadingCompo from './components/Loader/Lodind_compo.js';
import './components/QuizComponent.css';
import { lazyWithRetry, RouteErrorBoundary } from './lazyRoute.js';

// Route pages, downloaded on first visit
const Profile = lazyWithRetry(() => import("./components/Profile.js"));
const PrivacyPolicy = lazyWithRetry(() => import("./components/Privacy_policy.js"));
const BidHistory = lazyWithRetry(() => import("./components/Bid.js"));
const AccountHistory = lazyWithRetry(() => import('./components/Ac_statement.js'));
const SignupPage = lazyWithRetry(() => import('./components/User_Auth/Singn_up.js'));
const HowToPlay = lazyWithRetry(() => import("./components/How_to_play.js"));
const GameRates = lazyWithRetry(() => import('./components/Game_rule.js'));
const MyComponent = lazyWithRetry(() => import('./components/Game_type.js'));
const PaymentComponent = lazyWithRetry(() => import('./components/payment/Add_payment.js'));
const Withdrawal = lazyWithRetry(() => import('./components/wallet/Wth.js'));
const SangamComponent = lazyWithRetry(() => import('./components/SangamComponent.js'));
const PlayComponent = lazyWithRetry(() => import('./components/Play_Component.js'));
const RequestHistory = lazyWithRetry(() => import('./components/History.js'));
const LotusMatka = lazyWithRetry(() => import('./components/Download_Applocation.js'));
const MpinForm = lazyWithRetry(() => import('./components/User_Auth/Mpin.js'));
const OtpForm = lazyWithRetry(() => import('./components/User_Auth/Otp.js'));
const LoginMpin = lazyWithRetry(() => import('./components/User_Auth/Login_mpin.js'));
const AllBids = lazyWithRetry(() => import('./components/All_Bids.js'));
const ChartCompo = lazyWithRetry(() => import('./components/ChartCompo.js'));
const WalletMethod = lazyWithRetry(() => import('./components/WalletMethod.js'));
const AddFUnAuto = lazyWithRetry(() => import('./components/wallet/AddFUnAuto.js'));
const AddBankDetails = lazyWithRetry(() => import('./components/wallet/AddBankDetails.js'));
const FundsHistory = lazyWithRetry(() => import('./components/wallet/FundsHistory.js'));
const AddFundManual = lazyWithRetry(() => import('./components/wallet/AddFundManual.js'));
const SingleGame = lazyWithRetry(() => import('./components/SInglegame.js'));
const PaymentStatus = lazyWithRetry(() => import('./components/wallet/Payment_status.js'));
const QuizComponent = lazyWithRetry(() => import('./components/QuizComponent.js'));

// Pages preloaded in the background. LotusMatka is left out: its download.css (Tailwind/Bootstrap
// resets such as img{display:block}) is global and would restyle every page once loaded.
const ROUTE_PAGES = [
  Profile, PrivacyPolicy, BidHistory, AccountHistory, SignupPage, HowToPlay, GameRates, MyComponent,
  PaymentComponent, Withdrawal, SangamComponent, PlayComponent, RequestHistory, MpinForm,
  OtpForm, LoginMpin, AllBids, ChartCompo, WalletMethod, AddFUnAuto, AddBankDetails, FundsHistory,
  AddFundManual, SingleGame, PaymentStatus, QuizComponent,
];

// Clears a page-load error when the user moves to another page
function RoutePages({ children }) {
  const { pathname } = useLocation();
  return (
    <RouteErrorBoundary resetKey={pathname}>
      <Suspense fallback={<Loader isLoading={true} />}>{children}</Suspense>
    </RouteErrorBoundary>
  );
}

// One app-wide message toast: repeats are ignored while it is visible and a different
// message replaces its text, so messages never stack. A new toast shows once it has hidden.
const APP_TOAST_ID = 'app-message';
let lastToastMessage = null;
function showAppToast(message, type) {
  if (!toast.isActive(APP_TOAST_ID)) {
    lastToastMessage = message;
    toast(message, { ...toastCss, type, toastId: APP_TOAST_ID });
  } else if (message !== lastToastMessage) {
    lastToastMessage = message;
    toast.update(APP_TOAST_ID, { render: message, type });
  }
}

function MyComponents() {
  const dispatch=useDispatch();
 const navigate = useNavigate();
 const location = useLocation();
 const fullUrl = window.location.href; // Get the full URL
  const lastSegment = fullUrl.substring(fullUrl.lastIndexOf("/") + 1); // Extract the last segment
    const { loading,isUserLogedIn,Info } = useSelector((state) => state.users);
    // Last pathname seen, so the profile is refreshed once per route change
    const previousPathname = useRef('');
    console.log("+>>>>>>>>",isUserLogedIn,['login','sign-up','M_pin','otp','login_mpin'].includes(lastSegment));
    useEffect(()=>{
      if (isUserLogedIn && ['login','sign-up','M_pin','otp','login_mpin'].includes(lastSegment)) {
          navigate("/", { replace: true });
  }

  },[isUserLogedIn,lastSegment,navigate])

  const phoneNumber = Info?.phone_number;
  useEffect(() => {
    const routeChanged = location.pathname !== previousPathname.current;
    previousPathname.current = location.pathname;
    if(loading===false && isUserLogedIn && phoneNumber && routeChanged){
      let data = new FormData();
      data.append('phone_number',phoneNumber);
      dispatch(get_all_depends({request_type:'fetch_pofile',data}));
    }
  }, [location.pathname, loading, isUserLogedIn, phoneNumber, dispatch]);

  return null;
}

 function App () {
  const { loading,error,successMsg,isUserLogedIn,Info } = useSelector((state) => state.users);
  const dispatch=useDispatch();
  const [isLoading_compo,seisLoadingCompo]=useState(true);
  // Logged-in users whose status isn't 1 only get the quiz. Same result as `Info?.status != true`
  // (status arrives as '1'/'0'), written without loose equality.
  const showQuizOnly = isUserLogedIn && Number(Info?.status) !== 1;

  const touchStartY = useRef(0);
  const touchEndY = useRef(0);
  const holdTimer = useRef(null);
  const isHolding = useRef(false);
  const queryParams = new URLSearchParams(window.location.search);
  const [isTokenSet,setIsTOken]=useState(false);
  const fcmtoken = queryParams.get("fcm_token") || false;
  // Function to check if the user is at the top of the page
  const isAtTopOfPage = () => window.scrollY === 0;

  // Handle touch start (user presses down)
  const handleTouchStart = (e) => {
    touchStartY.current = e.touches[0].clientY;

    if (isAtTopOfPage()) {
      holdTimer.current = setTimeout(() => {
        isHolding.current = true;
      }, 100); // Long press threshold (900ms)
    }
  };

  // Handle touch move (user swipes)
  const handleTouchMove = (e) => {
    touchEndY.current = e.touches[0].clientY;
  };

  // Handle touch end (user lifts finger)
  const handleTouchEnd = () => {
    clearTimeout(holdTimer.current); // Clear hold timer

    if (
      isHolding.current &&
      touchEndY.current > touchStartY.current + 50 && // Detect swipe down (50px threshold)
      isAtTopOfPage()
    ) {
      let data = new FormData();
      data.append('phone_number',Info?.phone_number);
      dispatch(get_all_depends({request_type:'fetch_pofile',data})); 
      dispatch(get_all_depends({request_type:'get_games',data:data}));
      dispatch(get_all_depends({request_type:'get_rates',data:data}));  
    } 
    isHolding.current = false; // Reset hold flag
  };

  // Download every page's code in the background right after the first render, without waiting
  // for any API response, so opening a page later needs no network trip for its code
  useEffect(()=>{
    ROUTE_PAGES.forEach((page) => page.preload());
  },[])

  useEffect(()=>{
    const user_session = localStorage.getItem('user_session');
    const userObject = JSON.parse(user_session);
    if(userObject?.phone_number){
              dispatch(logged_user_storage(userObject));

    }
    const loadingTimer = setTimeout(() => {
      seisLoadingCompo(false);
    }, 0);
    return () => clearTimeout(loadingTimer);
   },[dispatch])

useEffect(()=>{
    if(fcmtoken){
         localStorage.setItem("fcm_token",fcmtoken);
    }
     const token = localStorage.getItem("fcm_token") || fcmtoken;
    if(Info?.phone_number && !isTokenSet && token){
           let data = new FormData();
          data.append('phone_number',Info?.phone_number);
          data.append('fcm_token',token);
          data.append('status',Info?.status);
          dispatch(setFcmToken(data));
          setIsTOken(true);
    }
   },[fcmtoken,Info,isTokenSet,dispatch])

  useEffect(()=>{
    if(error){
           showAppToast(error,'success');
           dispatch(clearmsg_promt({error:false}));
    }
   },[error,dispatch])
   useEffect(()=>{
    if(successMsg){
           showAppToast(successMsg,'error');
           dispatch(clearmsg_promt({error:true}));
    }
   },[successMsg,dispatch])

   useEffect(()=>{
    if(isUserLogedIn){
          let data = new FormData();
          data.append('phone_number',Info?.phone_number);
          dispatch(get_all_depends({request_type:'get_games',data:data}));
          dispatch(get_all_depends({request_type:'get_rates',data:data}));
    }
   },[isUserLogedIn,Info?.phone_number,dispatch])
   

  return (
    <div className="App"
    onTouchStart={handleTouchStart}
    onTouchMove={handleTouchMove}
    onTouchEnd={handleTouchEnd}
    >
      <ToastContainer/>
      {(isLoading_compo)?
      <LoadingCompo/>:''}
     <Router>
     {isUserLogedIn?<ComplexNavbar/>:''}
     {/* Space for the fixed navbar, which only shows when logged in */}
     {isUserLogedIn && <><br/><br/><br/><br/></>}
     <Loader isLoading={loading && !isLoading_compo} />
     <MyComponents />


            <RoutePages>
            {showQuizOnly ? (
            <Routes>
                          <Route path="/" element={<QuizComponent />} />
                          {/* Every other address goes to the quiz */}
                          <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            ) : (
            <Routes>
                          <Route path="/home" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:true}}>
                          <Home />
                          </ProtectedRoute>
                          } />

                          <Route path="/" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:true}}>
                          <Home />
                          </ProtectedRoute>
                          } />

                        
                         <Route path="/Login" element={<Login />} />
                         <Route path="/sign-up" element={<SignupPage />} />
                         <Route path="/M_pin" element={<MpinForm />} />
                         <Route path="/Otp" element={<OtpForm />} />
                         <Route path="/login_mpin" element={<LoginMpin />} />
                         
                           <Route path="/download-now" element={<LotusMatka/>}/>
                         <Route path="/profile" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <Profile />
                          </ProtectedRoute>
                          } />
                         
                          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                          <Route path="/how-to-play" element={<HowToPlay />} />

                          <Route path="/payment-status" getpay={true} element={<PaymentStatus/>} />

                          <Route path="/game-rates" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <GameRates />
                          </ProtectedRoute>
                          } />
                          <Route path="/my-bid" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <BidHistory />
                          </ProtectedRoute>
                          } />

                            <Route path="/all-bid" element={
                            <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                            <AllBids />
                            </ProtectedRoute>
                            } />

                          <Route path="/account-statement" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <AccountHistory />
                          </ProtectedRoute>
                          } />
                          <Route path="/game_type/:gameName" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <MyComponent />
                          </ProtectedRoute>
                          } />

                          <Route path="/:chart_ype/:gameName" element={
                          <ProtectedRoute isAuthenticated={{logged_in:true,bettingOn:'1',isHome:false}}>
                          <ChartCompo />
                          </ProtectedRoute>
                          } />


                          <Route path="/game_type/:gameName/:gameType" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <PlayComponent />
                          </ProtectedRoute>
                          } />

                        <Route path="/game_type_single/:gameName/:gameType" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                        <SingleGame/>
                        </ProtectedRoute>
                        } />

                          <Route path="/game_type/:gameName/half_sangam" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <SangamComponent key="half_sangam" />
                          </ProtectedRoute>
                          } />
                          <Route path="/game_type/:gameName/full_sangam" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <SangamComponent key="full_sangam" />
                          </ProtectedRoute>
                          } />
                          <Route path="/deposit" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <PaymentComponent />
                          </ProtectedRoute>
                          } />
                           <Route path="/withdraw" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <Withdrawal />
                          </ProtectedRoute>
                          } />   

                        <Route path="/wallet_histroy" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <WalletMethod/>
                        </ProtectedRoute>
                        } />   
                        <Route path="/add_fund_auto" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <AddFUnAuto/>
                        </ProtectedRoute>
                        } />   

                      <Route path="/add_fund_user" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <AddFundManual/>
                        </ProtectedRoute>
                        } />   


                        <Route path="/add_bank_details" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <AddBankDetails/>
                        </ProtectedRoute>
                        } />  

                         <Route path="/fund_histry/:TYPE" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <FundsHistory/>
                        </ProtectedRoute>
                        } />  




                          
                          <Route path="/request_history" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <RequestHistory />
                          </ProtectedRoute>
                          } />


            </Routes>
            )}
            </RoutePages>

            {(isUserLogedIn && Info?.status==='1')?<Footer/>:''}                  

      </Router>
    </div>

  );

}

export default App;
